import teamContent from '../content/team.json'

type TeamMemberContent = {
  order: number
  name: string
  title: string
  location?: string
  specialities: string[]
  description: string
  image?: string
}

const meetOurTeam = (teamContent.members as TeamMemberContent[])
  .slice()
  .sort((a, b) => a.order - b.order)
  .map(({ image, ...member }) => ({
    ...member,
    imageName: image || undefined,
  }))

export default meetOurTeam
